"use client";
import { jsx as o } from "react/jsx-runtime";
import { cn as p } from "@deputy-ai/common";
import { mergeProps as w } from "@deputy-ai/common/react";
import { cva as f } from "class-variance-authority";
import { Avatar as u } from "radix-ui";
import * as d from "react";
const n = {
  circle: "circle",
  square: "square"
}, t = {
  xs: "xs",
  sm: "sm",
  md: "md",
  lg: "lg",
  xl: "xl",
  "2xl": "2xl",
  "3xl": "3xl",
  "4xl": "4xl"
}, A = f("", {
  variants: {
    shape: {
      [n.circle]: "rounded-full",
      [n.square]: ""
    },
    size: {
      [t.xs]: "w-6 h-6 text-[15px]",
      [t.sm]: "w-8 h-8 text-[20px]",
      [t.md]: "w-10 h-10 text-[25px]",
      [t.lg]: "w-12 h-12 text-[30px]",
      [t.xl]: "w-14 h-14 text-[35px]",
      [t["2xl"]]: "w-16 h-16 text-[40px]",
      [t["3xl"]]: "w-20 h-20 text-[50px]",
      [t["4xl"]]: "w-24 h-24 text-[60px]"
    }
  },
  compoundVariants: [
    {
      shape: n.square,
      size: [t.xs, t.sm],
      class: "rounded-sm"
    },
    {
      shape: n.square,
      size: [t.md, t.lg],
      class: "rounded-md"
    },
    {
      shape: n.square,
      size: [
        t.xl,
        t["2xl"],
        t["3xl"],
        t["4xl"]
      ],
      class: "rounded-lg"
    }
  ],
  defaultVariants: {
    shape: n.circle,
    size: t.md
  }
}), v = d.createContext(null);
function z() {
  const s = d.useContext(v);
  if (!s)
    throw new Error(
      "Avatar compound components must be rendered within the Avatar component"
    );
  return s;
}
function V(s) {
  const { ref: r, size: e, shape: a, ...i } = s, c = typeof e == "string" ? e : void 0, x = A({
    size: c,
    shape: a
  }), l = typeof e == "number" ? e : void 0, m = l ? Math.floor(l / 2) : void 0, h = l && "w-(--size) h-(--size) text-(length:--text-size)", g = {
    ...l && { "--size": `${l}px` },
    ...m && { "--text-size": `${m}px` }
  };
  return /* @__PURE__ */ o(
    v.Provider,
    {
      value: { size: c, shape: a, shapeClassName: x, sizeClassName: h },
      children: /* @__PURE__ */ o(
        u.Root,
        {
          ref: r,
          ...w(
            {
              className: p(
                "relative flex shrink-0",
                x,
                h
              ),
              style: g
            },
            i
          )
        }
      )
    }
  );
}
function j({ className: s, ...r }) {
  const { shapeClassName: e, sizeClassName: a } = z();
  return /* @__PURE__ */ o(
    u.Image,
    {
      className: p(
        "aspect-square h-full w-full",
        e,
        a,
        s
      ),
      ...r
    }
  );
}
function k({ className: s, ...r }) {
  const { shapeClassName: e, sizeClassName: a } = z();
  return /* @__PURE__ */ o(
    u.Fallback,
    {
      className: p(
        "bg-muted flex h-full w-full items-center justify-center overflow-hidden",
        e,
        a,
        s
      ),
      ...r
    }
  );
}
const C = f(
  "absolute min-w-[18px] h-[18px] px-[3px] inline-flex justify-center items-center rounded-full bg-destructive text-[10px] text-white",
  {
    variants: {
      position: {
        "top-right": "-top-1 -right-1"
      }
    },
    defaultVariants: {
      position: "top-right"
    }
  }
);
function P({
  className: s,
  position: r,
  maxNumber: e = 99,
  renderMaxNumber: a,
  children: i,
  ...c
}) {
  const x = typeof i == "number" && i > e ? (a == null ? void 0 : a(e)) ?? /* @__PURE__ */ o("b", { children: "..." }) : i;
  return /* @__PURE__ */ o("div", { className: p(C({ position: r }), s), ...c, children: x });
}
export {
  V as Avatar,
  P as AvatarBadge,
  k as AvatarFallback,
  j as AvatarImage,
  n as AvatarShapes,
  t as AvatarSizes,
  A as avatarShapeVariants,
  C as badgeVariants
};
